import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UserState {
    user: unknown | null;
    checkingUserSession: boolean;
}

const initialState: UserState = {
    user: null,
    checkingUserSession: true,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<unknown | null>) {
            if (action.payload) {
                localStorage.setItem('tokenResponse', JSON.stringify(action.payload));
            } else {
                localStorage.removeItem('tokenResponse');
            }
            state.user = action.payload;
        },
        setCheckingUserSession(state, action: PayloadAction<boolean>) {
            state.checkingUserSession = action.payload;
        },
    },
});

export const { setUser, setCheckingUserSession } = userSlice.actions;
export default userSlice.reducer;
